<template>
  <div class="main-container">
    <router-view></router-view>

    <!-- Navbar section -->
    <HeaderDefault />

    <!-- breadcrumb strat -->

    <Breadcrumb>
      <template slot="breadcrumb">
        <h5 style="font-weight:300;text-align:center;" class="mb-1">
          Technologies & Healthcare
        </h5>
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title" style="font-weight:300;">
            Peer-Reviewed Articles and Papers of Sandrasoft
          </h2>
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <!-- portfolio item wrapper start -->
    <div
      class="portfolio-pages-wrapper"
      style="padding:45px 0 25px;background-color:rgb(246,245,249)"
    >
      <div class="container" style="max-width:1700px">
        <!-- <div
          style="width:100%;display:block;text-align:center;"
          class="mb-3"
          v-if="loading"
        >
          <b-spinner
            label="Spinning"
            style="margin: 0 auto 0 auto;"
          ></b-spinner>
        </div> -->
        <div v-if="loading" class="row" transition-duration="3s">
          <div
            class="wow move-up"
            :class="[`col-${12 / columes}`]"
            v-for="n in columes"
            :key="'col-' + n"
          >
            <div class="mb-4">
              <div class="portfolio-grid-caption">
                <div class="post-info" style="padding-bottom:30px">
                  <Skeleton :width="'100%'" :height="'60px'" />
                  <Skeleton :width="'40%'" :height="'20px'" />
                  <Skeleton :width="'100%'" :height="'240px'" />
                  <Skeleton :width="'50%'" :height="'20px'" />
                  <Skeleton :width="'70%'" :height="'20px'" />
                  <Skeleton :width="'20%'" :height="'20px'" />
                  <Skeleton :width="'100%'" :height="'20px'" />
                  <Skeleton :width="'80%'" :height="'20px'" />
                  <Skeleton :width="'100%'" :height="'20px'" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row" transition-duration="3s">
          <div
            class="wow move-up"
            :class="[`col-${12 / columes}`]"
            v-for="n in columes"
            :key="'col-' + n"
          >
            <div
              v-for="(item, ind) in episodes"
              :key="n + ind + item.publicNameUrl"
              class="mb-4"
              v-show="(ind + 1) % columes == n % columes"
            >
              <div class="portfolio-grid-caption">
                <div class="post-info" style="padding-bottom:10px">
                  <h5
                    style="font-size:1.35rem;font-weight:500;line-height:2rem;font-family:Roboto"
                    class="title"
                  >
                    <router-link
                      :to="`/blogs/${item.publicNameUrl}`"
                      class="title"
                    >
                      {{ item.publicTitle }}</router-link
                    >
                  </h5>
                  <p class="mt-2 mb-3" style="font-size:0.75rem;">
                    <span class="far fa-calendar meta-icon mr-1 "></span>
                    <span> {{ formatTimeShort(item.dateCreated) }}</span>
                    <span class="far fa-eye meta-icon mr-1 ml-4"></span>
                    <span>{{ item.viewCount }}</span>
                  </p>
                  <router-link :to="`/blogs/${item.publicNameUrl}`">
                    <div
                      class="editor_result_content post_card ibm mt-2"
                      v-if="item.publicHeadline"
                      v-html="item.publicHeadline"
                    ></div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span
          v-show="noData"
          style="font-size:1.2rem;width:100%;display:block;text-align:center;"
          >No articles yet!</span
        >
      </div>
    </div>
    <!-- portfolio item wrapper end -->

    <!-- footer section -->
    <FooterMain />
  </div>
</template>

<script>
import HeaderDefault from "@/components/sections/HeaderDefault";
import Breadcrumb from "@/components/Breadcrumb";
import FooterMain from "@/components/FooterMain";
import { Skeleton } from "vue-loading-skeleton";

export default {
  name: "PortfolioMasonry",
  components: {
    HeaderDefault,
    Breadcrumb,
    FooterMain,
    Skeleton,
  },
  computed: {
    columes() {
      if (window.innerWidth > 1800) {
        return 4;
      }
      if (window.innerWidth > 1400) {
        return 3;
      }
      if (window.innerWidth > 1000) {
        return 2;
      }
      return 1;
    },
  },
  data() {
    return {
      noData: false,
      loading: true,
      episodes: [],
    };
  },

  async mounted() {
    this.scrollToTop();
    if (typeof this.$redrawVueMasonry === "function") {
      this.$redrawVueMasonry();
    }
    this.onLoad();
    await this.ping();
    this.render();
  },

  methods: {
    async render() {
      var companyID = this.companyID;
      this.loading = true;
      var { items, totals, error } = await this.$httpClient.get(
        `/public/episodes/${companyID}`,
        {},
        { page: 1, limit: 100 }
      );
      this.loading = false;
      if (error) return;
      if (!totals) {
        return (this.noData = true);
      }
      this.episodes = items;
    },
    async onLoad() {
      await this.sleep(950);
      this.$redrawVueMasonry();
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>
